import Tree from "@/components/tree/Tree.vue";
import Cam from "@/components/cam/Cam.vue";
import { EventBus } from "@/services//EventBus.js";

const sortName = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};
const sortGroup = (a, b) => {
  if (!Array.isArray(a) && Array.isArray(b)) {
    return 1;
  }

  if (Array.isArray(a) && !Array.isArray(b)) {
    return -1;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return sortName(a[0], b[0]);
  }

  return sortName(a, b);
};

export default {
  name: "cams-list",
  props: {
    cams: {
      type: Array,
      default: () => []
    },
    preview: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    hovered: {
      type: Boolean,
      default: false
    },
    /**
     * принимает объект камеры и возвращает булево
     */
    isCamSelected: {
      type: Function
    }
  },
  components: {
    Tree,
    Cam
  },
  computed: {
    camGroups() {
      const groups = [];
      // для себя определим собственный разделитель
      const operateDelemeter = ":";
      // тут перечисляем все разделители в массиве
      const delimeterSymbols = [operateDelemeter];
      const pathDelimeter = new RegExp(
        "[" + delimeterSymbols.map(s => `\\${s}`).join("") + "]+"
      );

      this.cams.forEach(camObj => {
        const groupPath = camObj.name
          .split(pathDelimeter)
          .map(path => path.trim());
        if (groupPath.length > 1) {
          let existGroup = null;
          for (let i = 0; i < groupPath.length; i++) {
            const path = groupPath[i];
            if (i === 0) {
              existGroup = groups.find(
                g => Array.isArray(g) && g[0].value === path
              );
              if (!existGroup) {
                existGroup = [
                  {
                    value: path,
                    name: path,
                    children: []
                  }
                ];
                groups.push(existGroup);
              }
            } else {
              const pathItem = groupPath.slice(0, i + 1).join(operateDelemeter);
              const pathParent = groupPath.slice(0, i).join(operateDelemeter);
              if (
                !existGroup[0].children.find(item => {
                  return (
                    item.pathParent === pathParent && item.value === pathItem
                  );
                })
              ) {
                if (i !== groupPath.length - 1) {
                  existGroup[0].children.push({
                    name: path,
                    value: pathItem,
                    parent: i == 1 ? 0 : pathParent,
                    pathParent
                  });
                } else {
                  existGroup[0].children.push({
                    ...camObj,
                    name: path,
                    value: pathItem,
                    parent: i == 1 ? 0 : pathParent,
                    pathParent
                  });
                }

                existGroup[0].children.sort(sortName);
              }
            }
          }
        } else {
          groups.push(camObj);
        }
      });
      groups.sort(sortGroup);
      return groups;
    }
  },
  methods: {
    onCamDrag(data, event) {
      EventBus.$emit("cam:dragstart");
      console.log(this.$store.getters.getMode);

      event.dataTransfer.setData(
        "text",
        JSON.stringify({
          camera_id: data.camera_id,
          connection_id: "",
          mode: this.$store.getters.getMode
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/camsList/camsList.js